import { useEffect } from 'react';
import { useFetchGlobal } from '../../../../hooks/global-reducer/useFetchGlobal';
import { usedFunnelMapCrmOrgIds } from '../../configuration-canvas/utils/listFunnelMapCrmOrgIds';

// Loads global if not cached when a new CrmOrg is added to the funnel map
// Either in metadata elements or in funnels
export const usePreemptivelyLoadFunnelMapOrgs = (funnelMap: FunnelMap) => {
  const { fetchGlobal } = useFetchGlobal();
  const crmOrgIdsPresentInFunnelMap = usedFunnelMapCrmOrgIds(funnelMap).join(',');

  useEffect(() => {
    if (!crmOrgIdsPresentInFunnelMap) return;
    const crmOrgIds = crmOrgIdsPresentInFunnelMap.split(',');
    crmOrgIds.forEach((crmOrgId) => {
      fetchGlobal({ crmOrgId, skipIfAlreadyLoaded: true });
    });
  }, [crmOrgIdsPresentInFunnelMap, fetchGlobal]);
};
